<template>
    <Content v-if="isProductUnavailable">
        <span>Produto <strong>Indisponível</strong></span>
    </Content>
</template>

<script>
import { mapGetters } from "vuex";
import { Content } from "./style";

export default {
    name: "ProductUnavailable",
    components: {
        Content
    },
    computed: {
        ...mapGetters("products", ["isProductUnavailable"])
    }
};
</script>
